import React from 'react';

import Dashboard from 'components/Dashboard';
import { ChildrenProps } from 'models/props';
import { useIsLessThan } from 'fxs-utils';

import { FXSFullWidthCol } from './styles';

export default function FullWidthMainLayout({ children }: ChildrenProps) {
	const isLessThan833 = useIsLessThan(833);

	return (
		<Dashboard>
			<FXSFullWidthCol isLessThan833={isLessThan833}>
				{children}
			</FXSFullWidthCol>
		</Dashboard>
	);
}
